import React from 'react';

const Breadcrumb = ({ steps, currentStepIndex, stepConfigs, onStepClick }) => {
  // Custom scrollbar styles
  const scrollbarStyles = `
    .breadcrumb-scroll::-webkit-scrollbar {
      height: 4px;
    }
    .breadcrumb-scroll::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }
    .breadcrumb-scroll::-webkit-scrollbar-thumb {
      background: #ED6B64;
      border-radius: 10px;
    }
    .breadcrumb-scroll::-webkit-scrollbar-thumb:hover {
      background: #d85a54;
    }
  `;
  // Get readable step names from config - super simplified for breadcrumb
  const getStepName = (stepId) => {
    // Map specific step IDs to concise names
    const stepNameMap = {
      'product-selection': 'Product',
      'window-style': 'Style',
      'door-style': 'Style',
      'bifolding-door-style': 'Style',
      'internal-product-style': 'Style',
      'conservatory-style': 'Style',
      'veranda-style': 'Style',
      'veranda-pergola-style': 'Type',
      'conservatory-roof-type': 'Roof',
      'new-roof-type': 'New Roof',
      'postcode': 'Postcode',
      'dimensions': 'Requirements',
      'quantity': 'Requirements',
      'veranda-dimensions': 'Dimensions',
      'conservatory-roof-dimensions': 'Dimensions',
      'colour': 'Colour',
      'hardware': 'Hardware',
      'summary': 'Review'
    };

    return stepNameMap[stepId] || stepId;
  };

  // Only show steps up to and including current step
  const visibleSteps = steps.slice(0, currentStepIndex + 1);

  const handleStepClick = (index) => {
    // Only allow clicking on completed steps (going back)
    if (index < currentStepIndex && onStepClick) {
      onStepClick(index);
    }
  };

  return (
    <>
      <style>{scrollbarStyles}</style>
      <div className="breadcrumb-scroll mb-8 overflow-x-auto">
        <div className="mx-auto max-w-[1200px] px-4">
        {/* Breadcrumb Trail */}
        <nav className="flex items-center gap-2 text-sm">
          {visibleSteps.map((stepId, index) => {
            const isActive = index === currentStepIndex;
            const isCompleted = index < currentStepIndex;
            const isClickable = isCompleted;

            return (
              <React.Fragment key={stepId}>
                {/* Step Item */}
                <button
                  type="button"
                  onClick={() => handleStepClick(index)}
                  disabled={!isClickable}
                  className={`
                    flex items-center gap-2 whitespace-nowrap rounded-md px-3 py-1.5 transition-all
                    ${isActive ? 'bg-[#ED6B64] text-white font-semibold' : ''}
                    ${isCompleted ? 'text-gray-700 font-medium hover:bg-gray-100 cursor-pointer' : ''}
                    ${!isClickable ? 'cursor-default' : ''}
                  `}
                >
                  {/* Step Number/Icon */}
                  <span
                    className={`
                      flex h-5 w-5 items-center justify-center rounded-full text-xs
                      ${isActive ? 'bg-white text-[#ED6B64] font-bold' : ''}
                      ${isCompleted ? 'bg-[#ED6B64] text-white' : ''}
                    `}
                  >
                    {isCompleted ? (
                      <svg
                        className="h-3 w-3"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={3}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    ) : (
                      index + 1
                    )}
                  </span>

                  {/* Step Name */}
                  <span className="text-sm">
                    {getStepName(stepId)}
                  </span>
                </button>

                {/* Separator Arrow */}
                {index < visibleSteps.length - 1 && (
                  <svg
                    className="h-4 w-4 flex-shrink-0 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                )}
              </React.Fragment>
            );
          })}
        </nav>

        {/* Mobile Step Counter */}
        <div className="mt-3 text-center text-xs text-gray-500 md:hidden">
          Step {currentStepIndex + 1} of {steps.length}
        </div>
        </div>
      </div>
    </>
  );
};

export default Breadcrumb;
